import { connect } from 'react-redux';
import type { DividendNextStepsProps } from '@/pages/CompanyReport/components/Dividend';
import { DividendNextSteps } from '@/pages/CompanyReport/components/Dividend';
import { getSummary } from '@/pages/CompanyReport/redux/selectors';

const mapStateToProps = (state, ownProps): DividendNextStepsProps => {
  const summary = getSummary(state, ownProps);
  return {
    countryISO: summary.countryISO,
    industryPrimaryName: summary.industryData.primaryName,
  };
};

export default connect(mapStateToProps)(DividendNextSteps);
